import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../lib/api';
import type { LocalKeyword } from '../types/marketing';

export const useKeywords = () => {
  return useQuery({
    queryKey: ['keywords'],
    queryFn: async () => {
      const response = await api.get('/api/marketing/keywords/');
      const data = response.data as any;
      
      // Handle different response formats
      if (Array.isArray(data)) {
        return data;
      } else if (data.results) {
        return data.results;
      } else if (data.keywords) {
        return data.keywords;
      }
      
      // Default to empty array if unexpected format
      return [];
    },
  });
};

export const useCreateKeyword = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: async (keyword: Partial<LocalKeyword>) => {
      const response = await api.post('/api/marketing/keywords/', keyword);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['keywords'] });
    },
  });
};

export const useUpdateKeyword = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: async ({ id, ...data }: Partial<LocalKeyword> & { id: number }) => {
      const response = await api.patch(`/api/marketing/keywords/${id}/`, data);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['keywords'] });
    },
  });
};

export const useDeleteKeyword = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: async (id: number) => {
      const response = await api.delete(`/api/marketing/keywords/${id}/`);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['keywords'] });
    },
  });
};